import axios from "axios";
import type { TwoFactorChannel } from "@/types/organization";

export const resetPassword = async (email: string): Promise<void> => {
  await axios.post("/pf-auth/reset-password", { email });
};

export const setNewPassword = async (payload: {
  secret_token: string;
  password: string;
  confirm_password: string;
}): Promise<void> => {
  await axios.post("/pf-auth/reset-password/set", payload);
};

interface AuthenticateUserPayload {
  email: string;
  password: string;
  code: string;
  channel: TwoFactorChannel;
}

interface AuthenticateUserResponse {
  user_email: string | null;
  user_id: string | null;
  status: "2fa_required" | "success";
  channel?: TwoFactorChannel;
}

export const authenticateUser = async (payload: AuthenticateUserPayload) => {
  const response = await axios.post<AuthenticateUserResponse>("/pf-auth/login", payload);

  return response.data;
};

interface ResendCodePayload {
  email: string;
  channel: TwoFactorChannel;
}

export const resend2FACode = async (payload: ResendCodePayload): Promise<void> => {
  await axios.post("/pf-auth/resend-2fa-code", payload);
};

interface SsoDomainCheckResponse {
  sso_enabled: boolean;
  sso_mode?: "sso" | "both";
  organization_name?: string;
}

export const checkSsoDomain = async (email: string): Promise<SsoDomainCheckResponse> => {
  const response = await axios.get<SsoDomainCheckResponse>(
    `/pf-auth/sso/check-domain?email=${encodeURIComponent(email)}`,
  );
  return response.data;
};
